<template>
	<div class="settings-panel-area-header">
		<h4>
			{{header}}
				<div v-if="plusMinus" > {{open ? '-' : '+'}} </div>
			<img v-else
				:src="open ? require('@/assets/svg/chevronUp.svg') : require('@/assets/svg/chevronDown.svg')"
				class="caret"
			/>
		</h4>
	</div>
</template>

<script>
	export default {
		props: {
			header: [String],
			open: [Boolean],
			plusMinus: Boolean
		},
		components: {}
	}
</script>

<style lang="less">
	.settings-panel-area-header {
		color: var(--text-grey-primary);
		padding: 0 45px;
		h4 {
			display: flex;
			align-items: center;
			flex-direction: row;
			justify-content: space-between;
			margin-bottom: 0;
		}
		.caret {
			width: 9px;
			height: 5px;
		}
	}
</style>

